module.exports = __webpack_public_path__ + "static/media/红包_1.eba5b9a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_170/img/红包_1.png
// module id = 1511
// module chunks = 0